.input {
  height: var(--input-h);
  width: 100%;
  background: var(--surface-input);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  padding: 0 var(--space-4);
  font-size: var(--fs-ui);
  color: var(--text-primary);
  outline: none;
  user-select: text;
  transition: border-color var(--dur-fast) var(--ease);
}

.input::placeholder {
  color: var(--text-muted);
}

.input:focus {
  border-color: var(--accent);
  box-shadow: none;
}
